import Vue from 'vue'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue.js'

import { BCollapse }  from 'bootstrap-vue' //, ButtonPlugin, CardPlugin, CarouselPlugin, BForm, InputGroupPlugin, LayoutPlugin, LinkPlugin, ListGroupPlugin, ModalPlugin, }
Vue.component('b-collapse', BCollapse)
// Vue.component('b-form', BForm)

// Vue.use(ButtonPlugin, CardPlugin, CarouselPlugin, InputGroupPlugin, LayoutPlugin, LinkPlugin, ListGroupPlugin, ModalPlugin)


Vue.use(BootstrapVue)
Vue.use(IconsPlugin)